import { Link } from 'react-router-dom';
import './style.scss';

function FlipSide ({title, imageUrl, reverse, description, backgroundColor, color}) {

    const scrollToContentCircles = () => {
        const element = document.getElementById('contentcircles');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section className='flip-side-component'>
            <div className='container'>
                <div className={`flip-side ${reverse ? 'reverse' : ''}`}>
                    <div className='image-box'>
                        <img className='image' src={imageUrl} alt='vaciegeszsegkozpont' />
                    </div>
                    <div className='content' style={{ background: backgroundColor, color: color }}>
                        <h2 className='title'>{title}</h2>
                        <p className='description'>{description}</p>
                        <button className='button' onClick={ scrollToContentCircles} >Tovább</button>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FlipSide;
